var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReligion = function SvgReligion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#religion_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.995 119.989c33.134 0 59.994-26.86 59.994-59.995C119.989 26.861 93.129 0 59.994 0 26.861 0 0 26.86 0 59.995c0 33.134 26.86 59.994 59.995 59.994z",
    fill: "#D7DBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.578 68.18L68.376 19.787a3.438 3.438 0 00-3.274-2.587 3.427 3.427 0 00-3.427 3.416v47.499l18.903.065z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.18 92.431h28.17l-9.038-19.907a7.422 7.422 0 00-6.745-4.366H68.18v24.273z",
    fill: "#ABB3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.632 68.18a9.473 9.473 0 0018.946 0H61.632z",
    fill: "#CFCCCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.906 68.115V50.478",
    stroke: "#CFCCCA",
    strokeWidth: 6.548,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.105 77.653a9.473 9.473 0 009.473-9.473H68.18v9.004a9.33 9.33 0 002.925.47z",
    fill: "#7E8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.41 68.18l12.214-48.393a3.427 3.427 0 013.274-2.587 3.416 3.416 0 013.416 3.416v47.499l-18.903.065z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.809 92.431H23.651l9.026-19.907a7.4 7.4 0 016.734-4.366h12.398v24.273z",
    fill: "#ABB3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.357 68.18a9.473 9.473 0 11-18.946 0h18.946z",
    fill: "#CFCCCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.083 68.115V50.478",
    stroke: "#CFCCCA",
    strokeWidth: 6.548,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.884 77.653a9.473 9.473 0 01-9.473-9.473h12.398v9.004a9.22 9.22 0 01-2.925.47z",
    fill: "#7E8888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "religion_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v120H0V0z",
    fill: "#fff"
  })))));
};
export { SvgReligion as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgY2xpcC1wYXRoPSJ1cmwoI3JlbGlnaW9uX3N2Z19fY2xpcDApIj48cGF0aCBkPSJNNTkuOTk1IDExOS45ODljMzMuMTM0IDAgNTkuOTk0LTI2Ljg2IDU5Ljk5NC01OS45OTVDMTE5Ljk4OSAyNi44NjEgOTMuMTI5IDAgNTkuOTk0IDAgMjYuODYxIDAgMCAyNi44NiAwIDU5Ljk5NWMwIDMzLjEzNCAyNi44NiA1OS45OTQgNTkuOTk1IDU5Ljk5NHoiIGZpbGw9IiNEN0RCREIiLz48cGF0aCBkPSJNODAuNTc4IDY4LjE4TDY4LjM3NiAxOS43ODdhMy40MzggMy40MzggMCAwMC0zLjI3NC0yLjU4NyAzLjQyNyAzLjQyNyAwIDAwLTMuNDI3IDMuNDE2djQ3LjQ5OWwxOC45MDMuMDY1eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik02OC4xOCA5Mi40MzFoMjguMTdsLTkuMDM4LTE5LjkwN2E3LjQyMiA3LjQyMiAwIDAwLTYuNzQ1LTQuMzY2SDY4LjE4djI0LjI3M3oiIGZpbGw9IiNBQkIzQjMiLz48cGF0aCBkPSJNNjEuNjMyIDY4LjE4YTkuNDczIDkuNDczIDAgMDAxOC45NDYgMEg2MS42MzJ6IiBmaWxsPSIjQ0ZDQ0NBIi8+PHBhdGggZD0iTTY0LjkwNiA2OC4xMTVWNTAuNDc4IiBzdHJva2U9IiNDRkNDQ0EiIHN0cm9rZS13aWR0aD0iNi41NDgiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PHBhdGggZD0iTTcxLjEwNSA3Ny42NTNhOS40NzMgOS40NzMgMCAwMDkuNDczLTkuNDczSDY4LjE4djkuMDA0YTkuMzMgOS4zMyAwIDAwMi45MjUuNDd6IiBmaWxsPSIjN0U4ODg4Ii8+PHBhdGggZD0iTTM5LjQxIDY4LjE4bDEyLjIxNC00OC4zOTNhMy40MjcgMy40MjcgMCAwMTMuMjc0LTIuNTg3IDMuNDE2IDMuNDE2IDAgMDEzLjQxNiAzLjQxNnY0Ny40OTlsLTE4LjkwMy4wNjV6IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTUxLjgwOSA5Mi40MzFIMjMuNjUxbDkuMDI2LTE5LjkwN2E3LjQgNy40IDAgMDE2LjczNC00LjM2NmgxMi4zOTh2MjQuMjczeiIgZmlsbD0iI0FCQjNCMyIvPjxwYXRoIGQ9Ik01OC4zNTcgNjguMThhOS40NzMgOS40NzMgMCAxMS0xOC45NDYgMGgxOC45NDZ6IiBmaWxsPSIjQ0ZDQ0NBIi8+PHBhdGggZD0iTTU1LjA4MyA2OC4xMTVWNTAuNDc4IiBzdHJva2U9IiNDRkNDQ0EiIHN0cm9rZS13aWR0aD0iNi41NDgiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PHBhdGggZD0iTTQ4Ljg4NCA3Ny42NTNhOS40NzMgOS40NzMgMCAwMS05LjQ3My05LjQ3M2gxMi4zOTh2OS4wMDRhOS4yMiA5LjIyIDAgMDEtMi45MjUuNDd6IiBmaWxsPSIjN0U4ODg4Ii8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0icmVsaWdpb25fc3ZnX19jbGlwMCI+PHBhdGggZD0iTTAgMGgxMjB2MTIwSDBWMHoiIGZpbGw9IiNmZmYiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";